
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'


import { Core } from '../core/core'

import { SeTagGroupComponent } from './tag-group.component'

@NgModule({
  imports: [
	CommonModule
  ],
  declarations: [
    SeTagGroupComponent,
  ],
  exports: [
    SeTagGroupComponent,
  ],
})
export class SeTagGroupModule {}

export const SE_TAG_GROUP_MODULE_BUNDLE = `${Core.ANGULAR_MODULE}.tagGroup`

